import { Rating } from '@tvg/fuse-design/rating';
import withPrefetch from 'client/hoc/withPrefetch';
import { stringToChars } from 'client/utils/utils';
import { PLPGeneralFacetValue } from 'common/types/plp-data';
import React, { useMemo } from 'react';
import Checkbox from '../Checkbox';
import { CountStyled } from '../CountStyled/CountStyled';
import Fieldset from '../Fieldset';
import { SEOAnchorStyled } from '../SEOAnchorStyled/SEOAnchorStyled';

type RatingFacetGroupProps = {
  groupDescription: string;
  items: PLPGeneralFacetValue[];
  dataTestId?: string;
  error?: boolean;
  isFullWidth?: boolean;
  groupID?: string;
  onChange: (event: React.FormEvent<HTMLElement>) => void;
};

const SEOAnchor = withPrefetch(SEOAnchorStyled);

export function RatingFacetGroup({
  dataTestId: groupTestId,
  error,
  groupDescription,
  items,
  onChange,
  isFullWidth,
  groupID,
}: RatingFacetGroupProps) {
  const processedGroupID = useMemo(() => (groupID ? stringToChars(groupID) : undefined), [groupID]);

  return (
    <Fieldset
      className="fuse-checkbox-group fuse-checkbox-group--rating"
      dataTestId={groupTestId}
      onChangeCallback={onChange}
      legend={groupDescription}
    >
      {items.map(({ name, id, count, selected, url }) => (
        <SEOAnchor href={url} key={name} className="forSEO" tabIndex={-1}>
          <Checkbox
            error={!!error}
            name={name}
            key={name}
            value={id}
            checked={selected}
            dataTestId={groupTestId}
            fullWidth={isFullWidth}
            onChange={onChange}
            aria-label={`${name} stars, item count: ${count}`}
            componentId={processedGroupID}
          >
            <Rating dataTestId="facet-rating__stars" rating={Number.parseInt(name, 10)} />
            <CountStyled data-testid="facet-checkbox__count">{count}</CountStyled>
          </Checkbox>
        </SEOAnchor>
      ))}
    </Fieldset>
  );
}
